/**
 * @file index.jsx
 * @author Rishikesh
 * @date 2024-09-17
 * @description Manages the course informations and listings
 */
import React, { useState } from "react";
import { Box } from "@mui/material";

import { CourseList } from "./CourseList";
import { HeaderSection } from "./HeaderSection";
import { useFetchData } from "../../../components/hooks/useFetchData";

const Courses = () => {
  const [minLoading, setMinLoading] = useState(true);
  const [courseList, setCourseList] = useState([]);

  const { fetchData, loading } = useFetchData();

  const getAllCourses = async () => {
    const result = await fetchData("getcourses?showActive=0");
    if (result?.code === 200) {
      setCourseList(result.data);
    }
  };

  React.useEffect(() => {
    getAllCourses();
    const minLoadingTimer = setTimeout(() => {
      setMinLoading(false);
    }, 1500);

    return () => clearTimeout(minLoadingTimer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isLoading = minLoading || loading["getcourses?showActive=0"];

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        overflow="hidden"
      >
        <HeaderSection isLoading={isLoading} />
        <CourseList courses={courseList} isLoading={isLoading} />
      </Box>
    </>
  );
};
export default Courses;
